module.exports = __webpack_public_path__ + "static/media/image-6.dbe52eb7.webp";